module.exports = require("@material-ui/icons/ArrowDownward");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/icons/ArrowDownward"
// module id = 299
// module chunks = 0